export const INCIDENT_FORM_LIST = "INCIDENT_FORM_LIST";
export const INCIDENT_FORM_LIST_SUCCESS = "INCIDENT_FORM_LIST_SUCCESS";
export const INCIDENT_FORM_LIST_FAIL = "INCIDENT_FORM_LIST_FAIL";

export const UPLOAD_INCIDENT_FORM = "UPLOAD_INCIDENT_FORM";
export const UPLOAD_INCIDENT_FORM_SUCCESS = "UPLOAD_INCIDENT_FORM_SUCCESS";
export const UPLOAD_INCIDENT_FORM_FAIL = "UPLOAD_INCIDENT_FORM_FAIL";

export const UPDATE_INCIDENT_FORM = "UPDATE_INCIDENT_FORM";
export const UPDATE_INCIDENT_FORM_SUCCESS = "UPDATE_INCIDENT_FORM_SUCCESS";
export const UPDATE_INCIDENT_FORM_FAIL = "UPDATE_INCIDENT_FORM_FAIL";

export const GET_ADDED_QUESTIONS = "GET_ADDED_QUESTIONS";
export const GET_ADDED_QUESTIONS_SUCCESS = "GET_ADDED_QUESTIONS_SUCCESS";
export const GET_ADDED_QUESTIONS_FAIL = "GET_ADDED_QUESTIONS_FAIL";

export const DELETE_INCIDENT_QUESTION = "DELETE_INCIDENT_QUESTION";
export const DELETE_INCIDENT_QUESTION_SUCCESS = "DELETE_INCIDENT_QUESTION_SUCCESS";
export const DELETE_INCIDENT_QUESTION_FAIL = "DELETE_INCIDENT_QUESTION_FAIL";

export const UPDATE_INCIDENT_FORM_QUES = "UPDATE_INCIDENT_FORM_QUES";
export const UPDATE_INCIDENT_FORM_QUES_SUCCESS = "UPDATE_INCIDENT_FORM_QUES_SUCCESS";
export const UPDATE_INCIDENT_FORM_QUES_FAIL = "UPDATE_INCIDENT_FORM_QUES_FAIL";

export const EDIT_INICIDENT_FORM_ADMIN = "EDIT_INICIDENT_FORM_ADMIN";
export const EDIT_INICIDENT_FORM_ADMIN_SUCCESS = "EDIT_INICIDENT_FORM_ADMIN_SUCCESS";
export const EDIT_INICIDENT_FORM_ADMIN_FAIL = "EDIT_INICIDENT_FORM_ADMIN_FAIL";

export const SUBMIT_ADMIN_REVIEWD_FORM = "SUBMIT_ADMIN_REVIEWD_FORM";
export const SUBMIT_ADMIN_REVIEWD_FORM_SUCCESS = "SUBMIT_ADMIN_REVIEWD_FORM_SUCCESS";
export const SUBMIT_ADMIN_REVIEWD_FORM_FAIL = "SUBMIT_ADMIN_REVIEWD_FORM_FAIL";

export const GET_ALL_INCIDENT_FORM_DATA = "GET_ALL_INCIDENT_FORM_DATA";
export const GET_ALL_INCIDENT_FORM_DATA_SUCCESS = "GET_ALL_INCIDENT_FORM_DATA_SUCCESS";
export const GET_ALL_INCIDENT_FORM_DATA_FAIL = "GET_ALL_INCIDENT_FORM_DATA_FAIL";

export const GET_OLD_INCIDENT_FORMS = "GET_OLD_INCIDENT_FORMS";
export const GET_OLD_INCIDENT_FORMS_SUCCESS = "GET_OLD_INCIDENT_FORMS_SUCCESS";
export const GET_OLD_INCIDENT_FORMS_FAIL = "GET_OLD_INCIDENT_FORMS_FAIL";

export const SEND_MAIL = "SEND_MAIL";
export const SEND_MAIL_SUCCESS = "SEND_MAIL_SUCCESS";
export const SEND_MAIL_FAIL = "SEND_MAIL_FAIL";

export const INCIDENT_LOGS = "INCIDENT_LOGS";
export const INCIDENT_LOGS_SUCCESS = "INCIDENT_LOGS_SUCCESS";
export const INCIDENT_LOGS_FAIL = "INCIDENT_LOGS_FAIL";

export const ARRANGE_INICIDENT_QUES_ORDER = "ARRANGE_INICIDENT_QUES_ORDER";
export const ARRANGE_INICIDENT_QUES_ORDER_SUCCESS = "ARRANGE_INICIDENT_QUES_ORDER_SUCCESS";
export const ARRANGE_INICIDENT_QUES_ORDER_FAIL = "ARRANGE_INICIDENT_QUES_ORDER_FAIL";
